<script>
import { h } from 'vue';
import { stringToColor } from '~/utils/color_utils';

// Warning: This is a non-reactive component intended for usage in report tables.
// If you need the component to change when props are updated use
// AppAvatarInitial instead.
export default {
  name: 'ReportTableAvatarInitial',
  props: {
    text: {
      type: String,
      required: true,
    },
    classModifier: {
      type: String,
      default: '',
    },
  },
  render() {
    const text = this.text;
    const displayText = text[0].toUpperCase();
    const backgroundColor = stringToColor(text);
    const props = {
      class: `avatar_initial ${this.classModifier}`,
      style: {
        backgroundColor,
      },
    };

    return h('div', props, displayText);
  },
};
</script>
